import 'swiper/css/swiper.css';
import Swiper from 'swiper/js/swiper.min.js';
export default Swiper;